// Google Analytics Tracking ID
export const TRACKING_ID = process.env.REACT_APP_TRACKING_ID || "";
